import React, { Component } from 'react'
import styled from 'styled-components'
import media from '../../styles/media'

const RectangleWrapper = styled.div`
  border-radius: 2px;
  height: 100%;
  box-shadow: 0 2px 14px 0 rgba(64, 180, 228, 0.21);
  background-color: #ffffff;
  border: solid 1px rgba(64, 180, 228, 0.12);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  margin: auto;
  ${media.md`
    margin: 0px;  
    padding: 30px;  
    align-items: flex-start;
  `};
`

const Title = styled.h4`
  margin: 0px;
  text-align: center;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #40b4e4;
  font-size: 1.75rem;
`

const BodyText = styled.p`
  text-align: center;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: #3c4252;
  margin-bottom: 0;
  font-size: initial;
  ${media.md`
    text-align: left;
    font-size: 0.9rem;
  `};
`

function Rectangle(props) {
  const { title, text } = props

  return (
    <RectangleWrapper>
      <Title>{title}</Title>
      <BodyText>{text}</BodyText>
    </RectangleWrapper>
  )
}

export default Rectangle



// WEBPACK FOOTER //
// ./src/components/text/rectangle.js